import createReactComponent from '../createReactComponent';
export default createReactComponent('devices-check', 'IconDevicesCheck', [
  [
    'path',
    { d: 'M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4', key: 'svg-0' },
  ],
  [
    'path',
    {
      d: 'M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7',
      key: 'svg-1',
    },
  ],
  ['path', { d: 'M16 9h2', key: 'svg-2' }],
  ['path', { d: 'M15 19l2 2l4 -4', key: 'svg-3' }],
]);
